import * as React from 'react'
import { Link } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import users from 'modules/core/store/collections/users'

import { calendarEventEmployee } from 'modules/calendar/lib/calendarEventEmployee'
import { calendarEventCanSeeTimeoffTypes } from 'modules/calendar/lib/calendarLeaves'
import type { CalendarViewEvent } from 'modules/calendar/lib/munchers/types'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

import type LeaveStore from './LeaveStore'
import Row from './Row'

interface Props {
  event: CalendarViewEvent
  leaveStore: LeaveStore
}

const MonthEvent = (props: Props) => {
  const { navigation } = useNavigation()

  const {
    leaveStore,
    event: { model },
  } = props

  const employeeId = model.metadata('employee_id')
  const employeeFromCollection = employees.get(employeeId)

  const getTitle = () => {
    if (!employeeFromCollection) return '–'
    const userId = employeeFromCollection.attributes.access_id
    const user = users.get(userId)
    if (!user) {
      throw Error(`Error getting users with id = ${userId}`)
    }
    return user.fullName()
  }
  const title = getTitle()

  const leaveId = model.metadata('leave_id')
  const url = navigation.calendar.leaves.editLeave.fullPath({ leave_id: leaveId })

  const readLeavesPermission = (employee: Employee): boolean => {
    return employee.policy.can('readLeaves')
  }

  const onMouseEnterHandler = () => {
    leaveStore.hoveredLeaveId = model.metadata('leave_id')
  }

  const onMouseLeaveHandler = () => {
    leaveStore.hoveredLeaveId = null
  }

  const employee = calendarEventEmployee(model, employees)
  const canReadLeaves = !!employee && readLeavesPermission(employee)
  const isLeaveTypeVisible = calendarEventCanSeeTimeoffTypes(model)

  const row = (
    <Row
      calendarEvent={model}
      colored={canReadLeaves}
      visible={isLeaveTypeVisible}
      leaveStore={leaveStore}
      title={title}
    />
  )

  const commonAttr = {
    onMouseEnter: () => onMouseEnterHandler(),
    onMouseLeave: () => onMouseLeaveHandler(),
  }

  if (canReadLeaves) {
    return (
      <Link to={url} {...commonAttr}>
        {row}
      </Link>
    )
  }

  return <div {...commonAttr}>{row}</div>
}

export default observer(MonthEvent)
